import moment from "moment";
import React, { useEffect, useState } from "react";
import { Graph } from "react-d3-graph";
import { useHistory } from "react-router-dom";
import closeIcon from "../../../../assets/img/icons/close-icon-grey.svg";
import { config } from "./TrainingDataOrchestratorGraphConfig";
import "../TrainingDataGraphView.scss";
import { getNodeIconByType } from "../../d3-flow-chart/flowChartHelper";
import Box from "../../../common/Box";
import GraphSelectedDataCard from "../GraphSelectedDataCard";

const TrainingDataGraphLineageView = ({ llmInfo, width, datastoreId }) => {
  const [graphData, setGraphData] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const history = useHistory();

  const TrainingData = [
    {
      FileName: "Langchain",
      Version: "0.0.259",
      install_location: "/usr/home/sachin/.env/bin",
      github_link: "https://github.com/langchain-ai/langchain",
      license_type: "MIT License",
      documentation_site_link:
        "https://python.langchain.com/docs/get_started/introduction.html",
      pypi_link: "https://pypi.org/project/langchain/",
      size: "6.7 MB",
      sub_node: false,
      main_node: true,
      datastore_node: false,
      type: "langchain",
    },
    {
      FileName: "ChromaDB",
      Version: "0.4.5   ",
      install_location: "/usr/home/sachin/.env/bin",
      installed_via_package_manager: "PIP installation",
      github_link: "https://github.com/chroma-core/chroma",
      license_type: "Apache Software License",
      documentation_site_link: "https://docs.trychroma.com",
      pypi_link: "https://pypi.org/project/chromadb",
      size: "647 KB",
      sub_node: false,
      main_node: false,

      datastore_node: false,
      type: "vectorDB",
    },
    {
      FileName: "training.json",
      Location: "s3://sagemaker-us-east-1-099873896856/training.json",
      Source: "Configured",
      sensitive_labels: "SSN, PII, ADDRESS",
      size: "4.16 GB",
      type: "S3Bucket",
      training_date: "2023-05-10T04:32:36.491000",
      policy_violation: true,
      account: "099873896856",
      count: 4,
      sub_node: true,
      main_node: false,

      datastore_node: false,
    },
    {
      FileName: "RDS",
      Source: "Configured",
      sensitive_labels: "SSN, PII, ADDRESS",
      size: "4.16 GB",
      type: "RDSInstance",
      training_date: "2023-05-10T04:32:36.491000",
      policy_violation: true,
      account: "099873896856",
      count: 4,
      sub_node: true,
      main_node: false,

      datastore_node: false,
    },
  ];

  const handleRefChange = (ref) => {
    if (ref) ref.resetNodesPositions();
  };

  const nodeClicked = (data) => {
    setSelectedNode(data);
  };

  const getGraphData = (data) => {
    if (data) {
      data.nodes.map((node) => {
        node.height = "2rem";
        node.width = "2rem";
        node.data = {};
        node.data.image = {
          width: 40,
          height: 40,
          src: getNodeIconByType(node.type),
          margin: "10px auto 0 auto",
        };
        node.data.handleClick = nodeClicked;
        node.selected = false;
      });
    }

    data.links = data.links
      .filter((x) => data.nodes.find((y) => y.id === x.source))
      ?.filter((x) => data.nodes.find((y) => y.id === x.target));

    return data;
  };

  const getNodeLinkColor = (node) => {
    switch (node.source) {
      case "Configured":
        return "#3d61ff";
      case "Access Path":
        return "#fecf1c";
      case "Live Access":
        return "#FC4C02";
      default:
        return "#3d61ff";
    }
  };

  const getDataSources = () => {
    let startId = 1;
    const data = { nodes: [], links: [] };
    let datastoreNode = {
      id: startId++,
      datastore_node: true,
      is_primary: true,
      name: llmInfo?.name,
      source: "",
      x: 100,
      y: 100,
      heading: llmInfo?.name,
      datastoreId: datastoreId,
      tooltip_content: {
        name: llmInfo?.name,
        framework: llmInfo?.Framework,
        owner: llmInfo?.Owner,
        baseFamily: llmInfo?.family,
      },
    };

    data.nodes.push(datastoreNode);

    let modelPosition = datastoreNode.x;
    let mainNodeX = "";
    let mainNodeY = "";
    let mainId = "";

    // Generating Model nodes
    for (let index = 0; index < TrainingData.length; index++) {
      if (TrainingData[index].sub_node === false) {
        let modelNode = {
          id: startId++,
          datastore_node: TrainingData[index].datastore_node,
          is_primary: true,
          name: TrainingData[index].FileName,
          source: "",
          x: modelPosition + 250,
          y: 100,
          heading: llmInfo?.Name,
          datastoreId: datastoreId,
          type: TrainingData[index].type,

          tooltip_content: {
            name: TrainingData[index].FileName,
            size: TrainingData[index].size,
            version: TrainingData[index].Version,
            install_location: TrainingData[index].install_location,
            installed_via_package_manager:
              TrainingData[index].installed_via_package_manager,
            github_link: TrainingData[index].github_link,
            license_type: TrainingData[index].license_type,
            documentation_site_link:
              TrainingData[index].documentation_site_link,
            pypi_link: TrainingData[index].pypi_link,
          },
        };
        if (TrainingData[index].FileName === "Langchain") {
          mainNodeX = modelNode.x - 50;
          mainNodeY = modelNode.y;
          mainId = modelNode.id;
        }

        modelPosition = modelNode.x;
        data.nodes.push(modelNode);

        let link = {
          id: new Date().toISOString(),
          source: TrainingData[index].main_node
            ? modelNode.id
            : data.nodes[index].id,
          target: TrainingData[index].main_node
            ? data.nodes[index].id
            : modelNode.id,
          fontColor: getNodeLinkColor(modelNode),
          fontSize: "12",
          strokeWidth: 3,
          color: "#3d61ff",
          textAnchor: "middle",
        };
        data.links.push(link);
      }
    }
    let subNodeX = mainNodeX - 50;

    for (let index = 0; index < TrainingData.length; index++) {
      if (TrainingData[index].sub_node === true) {
        let trainingNode = {
          id: startId++,
          datastore_node: false,
          is_primary: false,
          name: TrainingData[index].FileName,
          datastoreId: datastoreId,
          source: TrainingData[index].Source,
          type: TrainingData[index].type,
          x: subNodeX,
          y: mainNodeY + 180,
          tooltip_content: {
            // name: TrainingData[index].FileName,
            type: TrainingData[index].type,
            location: TrainingData[index].Location,
            training_date: moment(
              moment.utc(TrainingData[index]?.training_date).toDate()
            )
              .local()
              .format("YYYY-MM-DD HH:mm:ss"),
            source: TrainingData[index].Source,
            sensitive_data: TrainingData[index].sensitive_labels,
            size: TrainingData[index].size,
          },
        };
        subNodeX = subNodeX + 190;
        data.nodes.push(trainingNode);

        let link = {
          id: new Date().toISOString(),
          source: trainingNode.id,
          target: mainId,
          fontColor: getNodeLinkColor(trainingNode),
          fontSize: "12",
          strokeWidth: 3,
          color: "#AC5AFF",
          textAnchor: "middle",
        };
        // let link2 = {
        //   id: new Date().toISOString(),
        //   source: mainId,
        //   target: trainingNode.id,
        //   fontColor: getNodeLinkColor(trainingNode),
        //   fontSize: "12",
        //   strokeWidth: 3,
        //   color: "#AC5AFF",
        //   textAnchor: "middle",
        //   class: "link2",
        // };

        data.links.push(link);
        // data.links.push(link2);
      }
    }
    return data;
  };

  const formatTitle = (title) => {
    let formatedTitle = title.replaceAll("_", " ");
    let arr = formatedTitle.split(" ");

    for (var index = 0; index < arr.length; index++) {
      arr[index] = arr[index].charAt(0).toUpperCase() + arr[index].slice(1);
    }
    return arr.join(" ");
  };

  const getRightPanel = () => {
    if (selectedNode && selectedNode !== "") {
      return (
        <GraphSelectedDataCard
          selectedNode={selectedNode}
          setSelectedNode={setSelectedNode}
        />
      );
    }
  };
  useEffect(() => {
    getRightPanel();
  }, [selectedNode]);

  useEffect(() => {
    setSelectedNode(null);
    if (TrainingData) {
      let sources = getDataSources();
      const graphDataset = getGraphData(sources);
      setGraphData({ nodes: graphDataset.nodes, links: graphDataset.links });
    } else {
      setGraphData({ nodes: [], links: [] });
    }
  }, [width, llmInfo]);

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
      }}
    >
      <div className="linear-graph">
        {graphData && (
          <Graph
            id="access-graph-id"
            data={graphData}
            config={config}
            ref={handleRefChange}
            width="200px"
          />
        )}
      </div>
      {getRightPanel()}
    </Box>
  );
};

export default TrainingDataGraphLineageView;
